import React, { Component } from 'react';
import './loader.css';
import { FadeLoader } from 'react-spinners';
import { Modal } from 'react-bootstrap';
import { setLoader } from "../../redux/actionCreators";
import { connect } from "react-redux";

class Loader extends Component {
    render() {
        let visibility;
        if (this.props.loader === true) {
            visibility = true;
        } else {
            visibility = false;
        }
        return (<Modal
                show={visibility}>
                    <Modal.Body  className='loader'> 
                    <FadeLoader
                            loading={true}
                            color={'#3370D1'}
                            size={45}
                    />
                    <div className='loader-title'>
                        <p>Estamos procesando los datos, por
                        favor espere un momento</p>
                    </div>
                    <div className='loader-content'>
                        <p>Si no eres redirigido en 5 minutos, verifica tu
                        conexión a internet y vuelve a intentarlo.</p>
                    </div>
                    </Modal.Body>
            </Modal>);

    }
}

const mapStateToProps = state => {
    return {
        loader: state.loader,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
